export const ExternalLibs = () => {
    return (
        <>
            {/*<script*/}
            {/*    async={true}*/}
            {/*    src="/js/featurebase-sdk.js"*/}
            {/*    // Key is important for deduplication if rendered multiple times*/}
            {/*    key="featurebase-sdk-script"*/}
            {/*/>*/}
        </>
    )
}